export default __webpack_public_path__ + "static/media/hypolake_logo.87a12fc6.svg";